'use client';

import { prepare_virtualPageUrl } from '@/lib/data-layer/utils';
import { RecourseRedirectContainer } from '@/src/features/recourse/recourse-container/recourse-container';
import { usePathname } from 'next/navigation';

export type RecourseSearchParams = {
  productId?: string;
  id?: string;
  amount?: string;
  maturity?: string;
  ct?: string;
};

export interface RecourseForwardProps {
  params: {
    page: string;
  };
  searchParams: RecourseSearchParams;
}

export const ClientPage = ({ params, searchParams }: RecourseForwardProps) => {
  const pathname = usePathname();
  const referrerUrl = prepare_virtualPageUrl({
    pathname: pathname as any,
    searchParams,
    isFullPath: true,
  });
  return <RecourseRedirectContainer referrerUrl={referrerUrl} params={params} searchParams={searchParams} />;
};
